<template>
	<div class="tb-fancy-loader loading">
		<div class="tb-fancy-loader-inner">
			<Lottie v-if="isMounted" 
				:options="animationOptions" 
				:height="248" 
				:width="248"
				@animCreated="handleAnimation" />
			<div class="tb-fancy-loader-content">
				<div class="tb-fancy-loader-headings">
					<h2 v-for="(message,index) in dynamicMessages"
						:class="activeHeading == index ? 'active' : ''"
						:key="index">
						{{message.text}}
					</h2>
				</div>
				<p>{{staticMessage}}</p>
			</div>
		</div>
	</div>
</template>
<script>
import LoadingJSON from '@/content/loading-animation.json'
import Lottie from 'vue-lottie';
import { mapState } from 'vuex'

export default {
	name: 'LoadingFancy', 
	props: ['finish'], 
	components: {
		Lottie
	},
	data: function(){
		return {
			isFinished: false,
			isMounted: false,
			animationOptions: {
				animationData: null, 
				autoplay: false, 
				loop: false
			},
			activeHeading: null,
			animation: null, 
			staticMessage: 'This may take up to 30 seconds.',
			dynamicMessages: [
				{ text: 'Retrieving your credit score', time: 4000 },
				{ text: 'Adding in your personal details', time: 4000 },
				{ text: 'Firing up the algorithm', time: 4000 },
				{ text: 'Crunching some numbers', time: 4000 },
				{ text: 'Laying out your options', time: 4000 }
			], 
			repeatDynamicMessages: true
		};
	},
	computed: {
		...mapState({
            vehicle: state => state.vehicle,
            finance: state => state.finance
		})
	},
	methods: {
		playLoading(force){
			this.animation.playSegments([0, 208], force);
		},
		playComplete(){
			this.isFinished = true;
			this.animation.playSegments([208, 260]);
		},
		handleComplete(){
			if (this.finish && !this.isFinished){
				this.playComplete();
			}
			else if (this.isFinished){
				this.$emit("finished");
			}
			else {
				this.playLoading(false);
			}
		},
		handleAnimation(o){
			this.animation = o; 
			o.addEventListener("complete", () => {
				this.handleComplete();
			});
			this.playLoading(true)
		}, 
		changeHeading(i){
			i = i < this.dynamicMessages.length ? i : 0;
			const h = this.dynamicMessages[i];
			this.activeHeading = i;
			setTimeout(() => {
				this.changeHeading(i+1)
			}, h.time);
		}
	}, 
	mounted(){
		this.animationOptions.animationData = LoadingJSON;
		this.activeHeading = 0;
		this.changeHeading(0);
		this.isMounted = true;
	}
}
</script>